<ng-container *appTranslate="let t">
  <new-ui-activity-table
    [activities]="notifications"
    [totalActivities]="notifications?.length"
    [disabled]="isBusy"
    [lazy]="false"
    [showProcess]="false"
    [showUser]="false"
    [showDate]="false"
    [showDescription]="true"
    [showNotificationClear]="true"
    (notificationCleared)="notificationCleared.emit($event)"
  />

  <p-drawer position="right" styleClass="w-overlay" [(visible)]="configVisible" [header]="t('settings.title')">
    <ng-template #content>
      <new-ui-notification-configuration
        [settings]="settings"
        (changed)="settingsChanged.emit($event)"
        (closed)="configVisible.set(false)"
      />
    </ng-template>
  </p-drawer>
</ng-container>
